import { Component } from '@angular/core';
@Component({
    selector: 'app-social-media-footer',
    templateUrl: './social-media-footer.component.html',
    styleUrls: ['./social-media-footer.component.scss'],
    standalone: false
})
export class SocialMediaFooterComponent {}
